import {Injectable, Injector} from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {AuthService} from 'app/core/auth/auth.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService,
                private _injector: Injector,
                private _toastr: ToastrService,
                private _router: Router) {
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            tap(
                event => this.handleResponse(req, event),
                error => this.handleError(req, error)
            ));
    }

    handleResponse(req: HttpRequest<any>, event): void {}

    handleError(req: HttpRequest<any>, event): void {


        const exceptions = ['changepass', 'sign-in', 'register', 'forgot-password'];

        if (event?.error?.message) {
            const errorMessage = event.error.message;
            this._toastr.error(errorMessage);
        }

        for (const exception of exceptions) {
            if (req.url.includes(exception)) {
                return;
            }
        }

        if (event.status === 500) {
            if (event?.error?.message === 'Unauthenticated.') {
                this._toastr.error('Došlo k chybě s autentizací.');
                this._authService.signOut();
                this._router.navigate(['/sign-in']).then();
                location.reload();
            } else {
                this._router.navigate(['/500-internal-server-error']).then();
            }
        }

        if (event.status === 422) {
            this._router.navigate(['/500-internal-server-error']);
        }
        if (event.status === 404) {
            this._router.navigate(['/404-not-found']);
        }
        if (event.status === 503) {
            this._router.navigate(['/maintenance']);
        }


    }
}
